<div class="col-sm-12 px-1">
  <div class="d-flex justify-content-center">
    <button
      class="btn btn-reset col text-center m-4"
      [disabled]="!enableReset"
      (click)="resetFilter()"
      >
      <i class="fas fa-redo-alt"></i>
      {{ app.text.RM.resetFilter }}
    </button>
  </div>
  @for (field of fieldsOnFilter; track field; let i = $index) {
    <div class="m-2 mt-0">
      @if (app.field.isVisibleInFilter(field) && !isAssemblySelected(field)) {
        <div
          class="filter-header"
          >
          <div
            class="px-2 py-3"
            (click)="isCollapsed[i] = !isCollapsed[i]"
            [attr.aria-expanded]="!isCollapsed[i]"
            >
            {{ app.field.getLabel(field) }}
            <span class="float-end">
              @if (!isCollapsed[i]) {
                <i class="far fa-chevron-down"></i>
              }
              @if (isCollapsed[i]) {
                <i class="far fa-chevron-up"></i>
              }
            </span>
            @if (
              app.filter.isSelected(field, app.filterTree.filters) &&
              !isCollapsed[i]
              ) {
              <div
                class="filter-selected-text"
                >
                {{ app.text.RM.selectedFilter }}
                <span>{{ app.filterTree.getSelectedOptions(field) }} </span>
              </div>
            }
          </div>
          <div
            [ngbCollapse]="!isCollapsed[i]"
            >
            @switch (app.filterTree.getFieldType(field)) {
              <!-- special case for part.partNumber since it has to search through all assemblies -->
              @case (partNumber) {
                <div class="filter-section">
                  <div>
                    <app-field
                      [field]="app.fieldId.part.partNumber"
                      [showLabel]="false"
                      [showMandatory]="true"
                      [typeaheadPlaceholder]="app.text.RM.filter"
                      >
                    </app-field>
                  </div>
                </div>
              }
              <!-- when the type of the field is input -->
              @case (input) {
                <div class="filter-section">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control search-input"
                      [(ngModel)]="filterInputs[field]"
                      (keydown.enter)="app.filterTree.filter(field, filterInputs[field])"
                      placeholder="{{ app.text.RM.search }}"
                      />
                    <button
                      class="btn search-button"
                      (click)="app.filterTree.filter(field, filterInputs[field])"
                      >
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                  @if (app.filter.isSelected(field, app.filterTree.filters)) {
                    <div
                      class="filter-selected-text"
                      >
                      {{ app.text.RM.selectedFilter }}
                      <span>{{ filterInputs[field] }}</span>
                    </div>
                  }
                </div>
              }
              <!-- on the tree view, we are displaying different options for obsolescenceStatusOptions  -->
              @case (specialStatus) {
                <div class="filter-section">
                  @for (status of obsolescenceStatusOptions; track status) {
                    <div>
                      {{ option }}
                      <input
                        #checkboxes
                        type="checkbox"
                        class="filter-input"
                        value="{{ status }}"
              [checked]="
                app.filter.isChecked(field, status, app.filterTree.filters)
              "
                        (click)="app.filterTree.filter(field, status)"
                        />
                      <span class="label">{{
                        app.filterTree.getOptionText(field, status)
                      }}</span>
                    </div>
                  }
                </div>
              }
              <!-- default is option type -->
              @default {
                <div class="filter-section">
                  @for (option of app.field.getOptions(field); track option) {
                    <div>
                      <input
                        #checkboxes
                        type="checkbox"
                        class="filter-input"
                        value="{{ option }}"
              [checked]="
                app.filter.isChecked(field, option, app.filterTree.filters)
              "
                        (click)="app.filterTree.filter(field, option)"
                        />
                      <span
                        class="label"
                        tooltipClass="tree-category-tooltip"
                        [ngbTooltip]="app.field.getOptionTooltipText(field, option)"
                      >
                        {{ app.field.getOptionDisplayText(field, option) }}
                      </span>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  }
</div>
